// Sim ↔ three.js space (§2.1): `world.x = sim.x; world.y = sim.z; world.z = sim.y`. The sim's
// +y points toward the camera, so the default three.js view direction (−z) looks toward sim −y.
import type { Object3D, Vector3 } from 'three';

export function simToWorld(x: number, y: number, z: number, out: Vector3): Vector3 {
  return out.set(x, z, y);
}

export function placeAt(o: Object3D, x: number, y: number, z: number): void {
  o.position.set(x, z, y);
}

/** three.js yaw (rotation about +Y) that turns local +Z toward the sim facing angle. */
export function yawForFacing(facing: number): number {
  return Math.PI / 2 - facing;
}

/** Same as `yawForFacing`, for meshes whose forward axis is local +X. */
export function yawForAngleX(angle: number): number {
  return -angle;
}
